import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import Arabic from "../../images/arabic title.png";
import { convertToRFT } from "../../utils/convertToRFT";
import { BoxesPacking } from "../features/BoxesPacking";
// import WarehousePrint from "./WarehousePrint";
import address from "../../images/arabic address.png";
import moment from "moment";
import { searchLedger } from "./httpCalls";

export const GenerateReport = ({ filteredData,ledgers ,salesTotal, purchasesTotal,selectedRegion=""}) => {
  // console.log("s", ledgers);
  // console.log("ledgersReport", filteredData);

//  console.log(salesTotal)
console.log('selectedRegion', selectedRegion)
console.log('ledgerssss', ledgers)

const todayDateHandler = ()=> {
  const now = new Date();
const year =now.getFullYear();
const month = String(now.getMonth()+1).padStart(2,"0");
const date = String(now.getDate()).padStart(2,"0");

return `${date}-${month}-${year}`
}


console.log(todayDateHandler());
 const salesTotalSum = filteredData?.reduce((acc,curr)=> {
  console.log('curr', curr)

    acc = acc + Number(curr?.saleTotal || 0)
    return acc || 0;
 },0)
 console.log('salesTotalSum', salesTotalSum)

 const purchaseTotalSum = filteredData?.reduce((acc,curr)=> {
  console.log('curr', curr)

   acc = acc + Number(curr?.purchaseTotal || 0)
  return acc || 0;
},0)
// console.log('salesTotalSum', salesTotalSum)
console.log('purchaseTotalSum', purchaseTotalSum)



  let doc = new jsPDF();
  const companyCode = localStorage.getItem("companyCode");
  let pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  doc.setFontSize(10);
  let finalY = "";

  let img = new Image();
  let baseUrl = localStorage.getItem("base_url");
  if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
    let snapshot = employeeLogo;
    img.src = snapshot;
  } else {
    let snapshot = localStorage.getItem("base_url");
    img.src = snapshot;
  }

  doc.addImage(img, "png", 73, 5, 60, 60);
  doc.setFontSize(22);
  doc.setFontStyle("bold");
  // doc.text(localStorage.getItem("company"), pageWidth / 2, 78, {
  //   align: "center",
  // });
  doc.setFontSize(24);
  doc.setFontStyle("bold");
  doc.text("Ledgers Report", pageWidth / 2, 94, {
    align: "center",
  });
  doc.setFontStyle("normal");
  doc.setFontSize(16);
  //   doc.text("Sale", pageWidth / 2, 104, {
  //     align: "center",
  //   });

  doc.text("Customer", 17, 120);
  //   doc.text((state?.ledger?.name || "").toString(), 45, 120);

  doc.setFontSize(18);
  doc.setFontStyle("bold");
  doc.text(localStorage.getItem("company"), 17, 70);
  doc.setFontSize(12);
  doc.setFontStyle("normal");
  doc.text(localStorage.getItem("email"), 17, 78);
  doc.text("Date", 165, 70);

  doc.text(todayDateHandler(), 178, 70);

  doc.text(selectedRegion, 17, 86);


  // doc.text(customer, 20, 70);

  doc.setFontSize(12);

  doc.text("Date", 150, 120);
  doc.setFontStyle("bold");

  //   doc.text(state.invoiceDate, 165, 120);
  doc.setFontStyle("normal");

  doc.text("Invoice No:", 150, 128);
  doc.setFontStyle("bold");

  //   doc.text(state.invoiceNumber.toString(), 173, 128);

//   doc.cell(17, 130, 70, 60, " ");

  doc.setFontStyle("normal");

  let rows = [];
  let col = ["#", "Ledger","Payment Type", "Purchase Khata", "Sale Khata", "Created"];
  const dataLedger = filteredData.length > 0 ? filteredData : ledgers ;
  dataLedger?.map((item, i) => {

    let temp = [
      i + 1,
      item?.name,
      item?.ledgerType,
      item?.purchaseTotal || 0,
      item?.saleTotal || 0,
      moment.unix(item?.created_at).format("DD-MM-YYYY"),
    ];
    rows.push(temp);
  });

doc.autoTable({
  head: [col],
  body: rows,
  startY: 100,
  headStyles: {     fillColor: [65, 140, 64], }
});


  //   Lower Portion


  doc.setFontStyle("bold");
  doc.text("Sales Khata", 140, 275);
  

     doc.text((selectedRegion ? salesTotalSum : salesTotal).toString() || 0, 170, 275);

     doc.text("Purchases Khata", 140, 283);
     doc.text((selectedRegion ? purchaseTotalSum : purchasesTotal).toString() || 0, 175, 283);

 
  // doc.setFontSize(8);
  // doc.text("Powered by www.managekaro.pk", 84, 285);
  // doc.text("0331 5921209", 95, 290);

  let temp = localStorage.getItem("template");

//   if (temp == null || temp == "standard") {
    doc.setFontSize(10);
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
//   }
};
